import {toggle_loader, disable_loader} from '../../theme/_loader';
import swal from 'sweetalert';
import Cookies from 'js-cookie';

export default function(stock_code, quantity, quiet = false) {

	return new Promise(function (resolve, reject) {

        if(!quiet) {

            //enable the loader to prevent user interaction
            toggle_loader();
        }

		const xhr = new XMLHttpRequest();
		xhr.addEventListener("readystatechange", function () {
			if (this.readyState === this.DONE) {

				try {

					//parse the response
					let response = JSON.parse(this.responseText);

					//disable the loader
					disable_loader();

					//resolve this request with the response from the API
					resolve(response.body_response);
				} catch(error) {

                    //create an error notification
                    swal({
                        title: 'Whoops, something went wrong',
                        text: 'We were unable to perform a search based on the details provided. Please review and try again.',
                        timer: 6000
                    });

					disable_loader();
					resolve(false);
				}
			}
		});

		xhr.open("POST", '/wp-json/laserred/tyres/stock');
		xhr.setRequestHeader("Accept", "*/*");
		xhr.setRequestHeader("Content-Type", "application/json");

		xhr.send(JSON.stringify({
			"stock_code": stock_code,
			"stock_requested": quantity
		}));
	});
};